import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";


export const GetAllContributionOfSecondTeamByAppGuid = createAsyncThunk(
  "ContributionOfSecondTeam/GetAllContributionOfSecondTeamByAppGuid",
  async (parameters, { rejectWithValue }) => {
    try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
            "api/SU_NT_WPB_ContributionOfSecondTeam/GetAllContributionOfSecondTeamByAppGuid",
            parameters
          );

          const data = response.data.result; // Assuming response has a "data" field
          return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetContributionOfSecondTeamById = createAsyncThunk(
    "ContributionOfSecondTeam/GetContributionOfSecondTeamById",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ContributionOfSecondTeam/GetContributionOfSecondTeamById",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const AddContributionOfSecondTeam = createAsyncThunk(
    "ContributionOfSecondTeam/AddContributionOfSecondTeam",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ContributionOfSecondTeam/AddContributionOfSecondTeam",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );


  export const DeleteContributionOfSecondTeam = createAsyncThunk(
    "ContributionOfSecondTeam/DeleteContributionOfSecondTeam",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ContributionOfSecondTeam/DeleteContributionOfSecondTeam",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );



  export const EditContributionOfSecondTeam = createAsyncThunk(
    "ContributionOfSecondTeam/EditContributionOfSecondTeam",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/SU_NT_WPB_ContributionOfSecondTeam/EditContributionOfSecondTeam",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const GetItemTypeForContributionOfSecondTeams = createAsyncThunk(
    "BudgetItemsRequestedFromSoman/GetItemTypeForContributionOfSecondTeams",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/DropDowns/GetItemTypeForContributionOfSecondTeams",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );



  export const GetSupportTypeForContributionOfSecondTeam = createAsyncThunk(
    "BudgetItemsRequestedFromSoman/GetSupportTypeForContributionOfSecondTeam",
    async (parameters, { rejectWithValue }) => {
      try {
          await initializeApiClient();
          const apiClient = await getApiClient();
          const response = await apiClient.post(
              "api/DropDowns/GetSupportTypeForContributionOfSecondTeam",
              parameters
            );
  
            const data = response.data.result; // Assuming response has a "data" field
            return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );





const ContributionOfSecondTeamReducers = createSlice({
  name: "FetchDataJson",
  initialState: {
    ContributionOfSecondTeamList: {},
    loadingContributionOfSecondTeamList: false,
    errorContributionOfSecondTeamList: null,

    ContributionOfSecondTeam: {},
    loadingContributionOfSecondTeam: false,
    errorContributionOfSecondTeam: null,


    AddContributionOfSecondTeam: {},
    loadingAddContributionOfSecondTeam: false,
    errorAddContributionOfSecondTeam: null,

    DeleteContributionOfSecondTeam: {},
    loadingDeleteContributionOfSecondTeam: false,
    errorDeleteContributionOfSecondTeam: null,

    EditContributionOfSecondTeam: {},
    loadingEditContributionOfSecondTeam: false,
    errorEditContributionOfSecondTeam: null,


    ItemTypeForContribution: [],
    loadingItemTypeForContribution: false,
    errorItemTypeForContribution: null,

    SupportTypeForContributionOfSecondTeam: [],
    loadingSupportTypeForContributionOfSecondTeam: false,
    errorSupportTypeForContributionOfSecondTeam: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllContributionOfSecondTeamByAppGuid.pending, (state, action) => {
        state.loadingContributionOfSecondTeamList = true;
        state.ContributionOfSecondTeamList = action.payload;
        state.errorContributionOfSecondTeamList = null;
      })
      .addCase(GetAllContributionOfSecondTeamByAppGuid.fulfilled, (state, action) => {
        state.loadingContributionOfSecondTeamList = false;
        state.ContributionOfSecondTeamList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllContributionOfSecondTeamByAppGuid.rejected, (state, action) => {
        state.loadingContributionOfSecondTeamList = false;
        state.errorContributionOfSecondTeamList = action.payload;
      });

      builder
      .addCase(GetContributionOfSecondTeamById.pending, (state, action) => {
        state.loadingContributionOfSecondTeam = true;
        state.ContributionOfSecondTeamList = action.payload;
        state.errorContributionOfSecondTeam = null;
      })
      .addCase(GetContributionOfSecondTeamById.fulfilled, (state, action) => {
        state.loadingContributionOfSecondTeam = false;
        state.ContributionOfSecondTeam = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetContributionOfSecondTeamById.rejected, (state, action) => {
        state.loadingContributionOfSecondTeam = false;
        state.errorContributionOfSecondTeam = action.payload;
      });

      builder
      .addCase(AddContributionOfSecondTeam.pending, (state, action) => {
        state.loadingAddContributionOfSecondTeam = true;
        state.AddContributionOfSecondTeam = action.payload;
        state.errorAddContributionOfSecondTeam = null;
      })
      .addCase(AddContributionOfSecondTeam.fulfilled, (state, action) => {
        state.loadingAddContributionOfSecondTeam = false;
        state.AddContributionOfSecondTeam = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddContributionOfSecondTeam.rejected, (state, action) => {
        state.loadingAddContributionOfSecondTeam = false;
        state.errorAddContributionOfSecondTeam = action.payload;
      });


      builder
      .addCase(DeleteContributionOfSecondTeam.pending, (state, action) => {
        state.loadingDeleteContributionOfSecondTeam = true;
        state.DeleteContributionOfSecondTeam = action.payload;
        state.errorDeleteContributionOfSecondTeam = null;
      })
      .addCase(DeleteContributionOfSecondTeam.fulfilled, (state, action) => {
        state.loadingDeleteContributionOfSecondTeam = false;
        state.DeleteContributionOfSecondTeam = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteContributionOfSecondTeam.rejected, (state, action) => {
        state.loadingDeleteContributionOfSecondTeam = false;
        state.errorDeleteContributionOfSecondTeam = action.payload;
      });


      builder
      .addCase(EditContributionOfSecondTeam.pending, (state, action) => {
        state.loadingEditContributionOfSecondTeam = true;
        state.EditContributionOfSecondTeam = action.payload;
        state.errorEditContributionOfSecondTeam = null;
      })
      .addCase(EditContributionOfSecondTeam.fulfilled, (state, action) => {
        state.loadingEditContributionOfSecondTeam = false;
        state.EditContributionOfSecondTeam = action.payload; // Assuming payload has the desired data
      })
      .addCase(EditContributionOfSecondTeam.rejected, (state, action) => {
        state.loadingEditContributionOfSecondTeam = false;
        state.errorEditContributionOfSecondTeam = action.payload;
      });


      builder
      .addCase(GetItemTypeForContributionOfSecondTeams.pending, (state, action) => {
        state.loadingItemTypeForContribution = true;
        state.ItemTypeForContribution = action.payload;
        state.errorItemTypeForContribution = null;
      })
      .addCase(GetItemTypeForContributionOfSecondTeams.fulfilled, (state, action) => {
        state.loadingItemTypeForContribution = false;
        state.ItemTypeForContribution = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetItemTypeForContributionOfSecondTeams.rejected, (state, action) => {
        state.loadingItemTypeForContribution = false;
        state.errorItemTypeForContribution = action.payload;
      });


      builder
      .addCase(GetSupportTypeForContributionOfSecondTeam.pending, (state, action) => {
        state.loadingSupportTypeForContributionOfSecondTeam = true;
        state.SupportTypeForContributionOfSecondTeam = action.payload;
        state.errorSupportTypeForContributionOfSecondTeam = null;
      })
      .addCase(GetSupportTypeForContributionOfSecondTeam.fulfilled, (state, action) => {
        state.loadingSupportTypeForContributionOfSecondTeam = false;
        state.SupportTypeForContributionOfSecondTeam = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetSupportTypeForContributionOfSecondTeam.rejected, (state, action) => {
        state.loadingSupportTypeForContributionOfSecondTeam = false;
        state.errorSupportTypeForContributionOfSecondTeam = action.payload;
      });
  },
});






export default ContributionOfSecondTeamReducers.reducer;
